<div class="upload-container">
    <div class="upload-header general-text-6">
      <span class="general-text-6">{{ configs.label }}</span>
      <span class="material-symbols-outlined mx-2 info-icon general-text-6"
      *ngIf="defaultConfigs.labelTooltip"
      data-toggle="tooltip"
      data-placement="top"
      [title]="defaultConfigs.labelTooltip">
          {{ defaultConfigs.tooltipIcon }}
  </span>
    </div>
  
    <div
      class="drag-drop-area"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <mat-icon class="search-icon">search</mat-icon>
      <span class="drag-placeholder general-text-6">{{ configs.placeholder }}</span>
      <input
        type="file"
        id="fileInput"
        (change)="onFileSelected($event)"
        multiple
        hidden
      />
      <button (click)="triggerFileInput()" class="browse-button">
        <span class="general-text-6">{{ configs.button.text }}</span>
      </button>
    </div>
  
    <div class="file-types general-text-8">
      {{ configs.fileTypes.join('/') }} file
    </div>
  </div>
  